import { cn } from '@lyearn/style';
import { LinkButton } from '@lyearn/ui';

import useSeeMoreList from '../../views/LearnerProfile/hooks/useSeeMoreList';
import { linkStyles } from './styles';
import { ShowMoreListProps } from './types';

function ShowMoreList<T>(props: ShowMoreListProps<T>) {
  const { items, renderItem, defaultShowCount } = props;

  const { shouldShowMore, itemsToShow, toggle, buttonText, endIcon } = useSeeMoreList(
    items,
    defaultShowCount,
  );

  return (
    <>
      {itemsToShow.map((item) => renderItem(item))}
      {shouldShowMore ? (
        <LinkButton
          className={cn(linkStyles, 'py-2 px-4')}
          color={'internal'}
          endIcon={endIcon}
          onClick={toggle}>
          {buttonText}
        </LinkButton>
      ) : null}
    </>
  );
}

export default ShowMoreList;
